import dompurify from 'dompurify'

export const MENTION_MARKUP = '@{+{+{__display__}+}+}'

// matches anything starting with an @ and followed by anyhting inside [], .e.g. @[My Name]
// FYI- we need the mention to be in the format `@[firstName lastName]` including the brackets, since it
// is saved in comment as plain text, the brackets indicate the start and end of the mention display name
const MENTION_REGEX = /@{\+{\+\{([^;/={}#$%!]+)}\+}+\+}/g

export const stripMentionMarkers = (text: string) => text.replace(MENTION_REGEX, '@$1')

export const parseCommentMentionsToHTML = (text: string, authorName?: string) => {
  const mentions = text.match(MENTION_REGEX)
  let transformedString = text

  if (mentions) {
    for (const mention of mentions) {
      const mentionWithoutBrackets = mention.replace(/({\+{\+{)/g, '').replace(/(}\+}\+})/g, '')
      transformedString = transformedString
        .split(mention)
        .join(`<span style="color: #175a92 !important;">${mentionWithoutBrackets}</span>`)
    }
  }

  if (authorName) {
    const author = `<span style="font-size: bold; font-size: 14px; font-family: 'Inter'; font-weight: 700; font-style: normal;">${authorName}: </span>`
    transformedString = author + transformedString
  }

  transformedString = transformedString.replace(/(?:\r\n|\r|\n)/g, '<br>')
  transformedString = dompurify.sanitize(transformedString)

  return transformedString
}

// Return an array of user ids from an html (mentioned users)
// If there are none return, an empty array
export const getMentionedUserIds = (text: string): number[] => {
  var el = document.createElement('html')
  el.innerHTML = text

  const ids = Array.from(el.getElementsByTagName('smart-link'))
    .map((user) => user.getAttribute('data-user-id'))
    .map(String)
    .map((userId) => parseInt(userId))
    .flat()

  return [...new Set(ids)]
}
